<template>

	<!-- content -->
	<div id="content" class="container board-list search-result">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<h2 class="tit_page">검색 결과</h2>
			<!-- 리스트 옵션 -->

			<form @submit.prevent="doSearch(params.searchText)">
				<div class="board_search">
					<div class="input_box">
						<input type="text" name="" class="inp" placeholder="내용을 입력해 주세요." v-model="params.searchText">
						<button type="submit"><img src="/ssflex_cs1/assets/img/common/ico/ico_search.svg" alt="검색"></button>
					</div>
				</div>
				<strong><span>'{{ searchText }}'</span>에 대한 {{ searchCount }}건의 검색결과</strong>
			</form>

			<template v-for="(boardInfoVO, index) in boardMap">
				<div class="search_board">

					<template v-if="boardInfoVO.boardList != null && boardInfoVO.boardList.length > 0">
						<h3 class="board_title">{{ boardInfoVO.boardName }}</h3>

						<list-webzine v-if="boardInfoVO.boardMode === 'webzine'" :board-info="boardInfoVO" :board-list="boardInfoVO.boardList" @goBoardOne="goView" :for-app="true"></list-webzine>
						<list-basic v-else-if="boardInfoVO.boardMode === 'basic'" :board-info="boardInfoVO" :board-list="boardInfoVO.boardList" @goBoardOne="goView" :for-app="true"></list-basic>
						<list-gallery v-else-if="boardInfoVO.boardMode === 'gallery'" :board-info="boardInfoVO" :board-list="boardInfoVO.boardList" @goBoardOne="goView" :for-app="true"></list-gallery>
						<list-faq v-else-if="boardInfoVO.boardMode === 'faq'" :board-info="boardInfoVO" :board-list="boardInfoVO.boardList" @goBoardOne="goView" :for-app="true"></list-faq>
						<list-classic v-else :board-info="boardInfoVO" :board-list="boardInfoVO.boardList" @goBoardOne="goView" :for-app="true"></list-classic>

						<template v-if="boardInfoVO.boardCount > 4">
							<div class="board_more">
								<router-link :to="'/app/board/' + boardInfoVO.boardKey + '/?mode=list&searchText=' + searchText" class="btn btn-lg btn-dark">더보기</router-link>
							</div>
						</template>

					</template>
				</div>

			</template>


			<template v-for="(item, index) in eduMapList" v-if="item.list.length > 0">
				<div class="search_board">
					<h3 class="board_title">{{ item.cateCodeVO.codeName }}</h3>
					<edu-list :edu-list="item.list" :for-app="true"></edu-list>

					<template v-if="item.count > 4">
						<div class="board_more">
							<router-link :to="'/app/education/main/' + item.cateCodeVO.code + '/?mode=list&searchText=' + searchText" class="btn btn-lg btn-dark">더보기</router-link>
						</div>
					</template>

				</div>
			</template>

			<div class="search_board" v-if="eduCourseCount > 0">
				<h3 class="board_title">교육 과정</h3>
				<course-list :course-list="eduCourseMap"></course-list>
				<template v-if="eduCourseCount > 4">
					<div class="board_more">
						<router-link :to="'/app/education/course/'" class="btn btn-lg btn-dark">더보기</router-link>
					</div>
				</template>
			</div>

		</div>
	</div>
	<!--//content -->

</template>

<script>
import ListBasic from "@/cs1/components/boards/lists/listBasic";
import ListClassic from "@/cs1/components/boards/lists/listClassic";
import ListWebzine from "@/cs1/components/boards/lists/listWebzine";
import ListGallery from "@/cs1/components/boards/lists/listGallery";
import ListFaq from "@/cs1/components/boards/lists/listFaq";
import EduList from "@/cs1/components/educations/main/eduList";
import CourseList from "@/cs1/components/educations/course/courseList";
import webUtils from "@/commons/utils/web.utils";

export default {
	name: "appSearchers",
	components: {EduList, ListFaq, ListGallery, ListWebzine, ListClassic, ListBasic, CourseList},
	data() {

		var params = this.pageUtils.Params();
		params.size = 4;
		params.searchText = this.stringUtils.toUTF8(this.$route.params.searchText)

		return {

			searchText: this.stringUtils.toUTF8(this.$route.params.searchText),
			params,

			// 전체 카운팅
			searchCount: 0,

			// 게시물
			boardKeyList: [
				"news_feeds",
				"trend_events",
				"success_examples",
				"guide_function",
				"guide_install",
				"faq",
				"company",
				"company_anonymous"
			],
			boardMap: [],

			// 교육
			eduMapList: [
				{cateCode: "200101", list: [], count: 0},
				{cateCode: "200102", list: [], count: 0},
			],

			eduCourseMap: [],
			eduCourseCount: 0

			// TODO : 쇼핑몰

		}
	},
	created() {
		this.searchProc()

	},
	mounted() {
	},
	methods: {
		doSearch(_searchText) {
			this.searchText = _searchText
			if (this.searchText.length === 0) {
				this.swalUtils.fire("검색어를 입력해 주세요.", "", "question")
			} else {
				this.webUtils.goTo(this, `/app/searcher/${this.stringUtils.toBase64(this.searchText)}`, true, true, true)
			}
		},

		async searchProc() {
			const self = this


			// 게시판 정보 목록 동기로 조회
			this.$eventBus.$emit("startProgress", 1)
			for (const key of self.boardKeyList) {
				const infoVO = await self.getBoardInfo(key);
				self.boardMap.push(infoVO)
			}
			this.$eventBus.$emit("doneProgress", 1)

			// 게시물코드 별로 게시물 검색
			for (let infoVO of this.boardMap) {
				this.getBoardList(infoVO.boardKey)
			}
			// 전체 게시물 조회 결과물
			console.log(this.boardMap)

			// 교육 조회
			this.getEduMainList();
			this.getEduCourseList();

			// 최상위 스크롤
			this.$nextTick(() => this.webUtils.scrollTo('#content'))
		},


		getBoardInfo(_boardKey) {

			const self = this
			return new Promise((resolve, reject) => {
				self.axiosCaller.get(self, self.APIs.BOARDS + "/getBoardInfo", {
					boardKey: _boardKey,
					isLogin: this.isLogin(),
				}, (res) => {
					const result = res.data;
					if (result.status === "ok") {
						resolve(result.boardInfoVO)
					}
				}, (res) => {
					console.log(res)
				})
			});

		},


		getBoardList(_boardKey) {

			const self = this
			this.params.isLogin = this.isLogin()

			var temp = JSON.parse(JSON.stringify(this.params))

			console.log(temp)

			temp.boardKey = _boardKey

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.BOARDS + "/getBoardList", temp, (res) => {
				var result = res.data
				if (result.status === "ok") {

					for (let infoVO of this.boardMap) {
						if (infoVO.boardKey === _boardKey) {

							// 각 게시물배열에 하위 목록 추가
							infoVO.boardList = result.boardMap.list
							infoVO.boardCount = result.boardMap.count

							// 전체검색 카운팅
							self.searchCount += result.boardMap.count
						}
					}

				} else {
					this.swalUtils.gritter("Error", result.msg, "error")
				}
				this.$eventBus.$emit("doneProgress")
			})

		},


		goView(_idx) {
			console.log(_idx)
		},


		getEduMainList() {

			const self = this

			var temp = JSON.parse(JSON.stringify(this.params))

			for (let item of this.eduMapList) {
				temp.cateCode = item.cateCode

				this.$eventBus.$emit("startProgress", 2)
				this.axiosCaller.get(this, this.APIs.EDU_MAIN + "/", temp, async (res) => {
					this.$eventBus.$emit("doneProgress", 2)

					const result = res.data
					console.log(result)
					if (result.status === "ok") {

						item.cateCodeVO = await self.getCodeOne(item.cateCode)
						item.list = result.list
						item.count = result.count
						self.searchCount += result.count

						console.log(this.eduMapList)
					} else {
						console.log(result.msg)
					}

				})

			}

		},

		getEduCourseList() {

			const self = this

			var temp = JSON.parse(JSON.stringify(this.params))

			this.axiosCaller.get(this, this.APIs.EDU_COURSE + "/", temp, async (res) => {
				this.$eventBus.$emit("doneProgress", 2)

				const result = res.data
				console.log("EduCourseVO", result)
				if (result.status === "ok") {
					self.eduCourseMap = result.list
					self.eduCourseCount = result.count
					self.searchCount += result.count
				} else {
					console.log(result.msg)
				}

			})

		}


	}
}
</script>

<style scoped>

</style>
